import { donorConnectTabs } from '../../donor-connect/models/tabs';

export const tabMap = [
    { id: 1, name: donorConnectTabs.UNASSIGNED, url: '/ilda/unassigned' },
    { id: 2, name: donorConnectTabs.TODO, url: '/ilda/to-do' },
    { id: 3, name: donorConnectTabs.MINE, url: '/ilda/assigned-to-me' },
    { id: 4, name: donorConnectTabs.ALL, url: '/ilda/all' }
];